<form [formGroup]="form" class="password-form">
  <h2 class="title">Войдите по паролю</h2>

  <sd-form-field label="Ваш телефон" [isShrinked]="true">
    <input type="tel" class="form-control" formControlName="phone" sdPhoneMaskFix autofocus />
  </sd-form-field>

  <sd-form-field label="Пароль" [isShrinked]="true">
    <input type="password" class="form-control" formControlName="password" placeholder="Введите пароль" />
  </sd-form-field>

  <button sdButton type="accent" (click)="login()" class="login-button">Войти</button>

  <button sdLink (click)="toggleAuthMethod()" class="auth-method-toggle-btn" type="unset">Вход по СМС</button>
</form>
